import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export const NotFound = () => {
	const { i18n } = useTranslation();
	const lang = i18n["language"] || "it";

	return (
		<div className="not-found">
			<h1 className="_big centered">404</h1>
			<p className="_base centered">Pagina non trovata.</p>
			<Link to={`/${lang}`} className="button">Home</Link>
		</div>
	);
};
